export default __webpack_public_path__ + "static/logo-cfl-dark-4a84f12366468bd21d195a144b5f8e72.svg";